export const commaToDotSeparator = (number: string | number) => {
    return number.toString().replace(',', '.');
};
